import type { Theme } from '@fluentui/react-components';

import { getTypographyValuesInRemUnits } from './typography';

/**
 * Takes Fluent 9 theme and returns a new Fluent 9 theme with typography px values converted to rems.
 */
export const createCoreUIFluentTheme = (theme: Theme): Theme => ({
  ...theme,
  ...getTypographyValuesInRemUnits(theme),
});
